import { Button, Callout, Dialog, EmptyState, Icons, Intent, ListItem, QueryList, Spinner, Tag } from "construct-ui";
import SiteSoldToShipToSpecialModel from "../../../models/site-management/site-sold-to-ship-to-special.model";
import ViewBase from "../../view-base.view";

export default function SiteSoldToShipToSpecialUpdateDialog() {

  ViewBase.call(this);

  const DEFAULT_UPDATE_ITEM = { repSoldToCode: '' }

  let isSearching = false;
  let itemList;
  let selectedItem = {};
  let updateItem = DEFAULT_UPDATE_ITEM;
  let representativeShipToNameOrId = '';

  let onClose = (reload) => {}

  const clearSelectedItemList = () => {
    selectedItem = {};
  }

  const search = () => {
    isSearching = true;
    SiteSoldToShipToSpecialModel.searchRepresentativeShipTo(representativeShipToNameOrId)
      .then((result) => {
        itemList = result;
      })
      .catch((error) => {
        this.handleError(error);
      }).finally(() => {
        isSearching = false;
      });
  };

  const clearSearchFilter = () => {
    representativeShipToNameOrId = '';
  }

  function renderItem(item, index) {
    return m(ListItem, {
      label: item.name,
      selected: selectedItem.code === item.code
    })
  }

  function handleSelect(item, e, index) {
    selectedItem = item
  }

  function renderSelectedLabel(item) {
    if (item.name) {
      return item.name;
    }

    let itemName = itemList?.find(i => i.code === item.code)?.name;
    if (itemName) {
      item.name = itemName;
      return itemName;
    }

    return '';
  }

  const handleUpdate = () => {
    this.showLoading();
    const payload = {
      siteId: updateItem.siteID,
      gscmDivision: updateItem.gscmDivision,
      representativeSoldToCode: selectedItem.code
    }
  
    SiteSoldToShipToSpecialModel.updateRepresentativeShipTo(payload)
    .then(() => {
        this.showMessage(this.getText('EM00000004', 'Success'), '', () => {
          updateItem.repSoldToCode = selectedItem.code
          clearSearchFilter();      
          onClose(true);
        });
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  let Content = {
    view: (vnode) => {
      return m('.container',
        // Selected section
        m('.d-flex.justify-content-between.gap-2',
          m('.d-flex.gap-2',
            m('label.form-label', this.getText("LT00000825", "Selected item"))
          ),
          m('.d-flex.gap-2',
            m('a.btn.btn-link.p-0', {
              onclick: clearSelectedItemList
            }, this.getText("LT00000345", "Clear all")),
          )
        ),
        m('.card.mb-3',
          m('.card-body.overflow-auto', { style: 'min-height: 51px; max-height: 82px;' },
            m('.d-flex.flex-wrap.gap-1',
              (selectedItem.code)
                ? m(Tag, {
                    class: 'm-0',
                    label: renderSelectedLabel(selectedItem),
                    onRemove: () => {
                      selectedItem = {}
                    }
                  })
                : m(EmptyState, {
                  content: this.getText("LT00000318", "No items selected. Please search and select from the section below."),
                  style: 'color: var(--is-inactive-gray)',
                })
            ),
          )
        ),
        // Search section
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-4',
              m('.col-12',
                m('.d-flex.flex-wrap.justify-content-end.gap-2',
                  m('.flex-grow-1', { style: 'min-width: 60%;' },
                    m('input.form-control[type=text]', {
                      placeholder: this.getText("LT00000826", "Sold-To Code / Name"),
                      onchange: e => { representativeShipToNameOrId = e.target.value },
                      value: representativeShipToNameOrId,
                    }),
                  ),
                  m('.d-flex.gap-2',
                    m(Button, {
                      label: this.getText("LT00000001", "Search"),
                      intent: Intent.PRIMARY,
                      loading: isSearching,
                      onclick: search,
                    }),
                    m(Button, {
                      label: this.getText("LT00000031", "Clear"),
                      outlined: true,
                      onclick: clearSearchFilter,
                    })

                  ),
                ),
              ),
              m('.col-12.position-relative', { style: 'min-height: 180px;' },
                itemList && itemList.length > 0 ?
                  m(QueryList, {
                    filterable: false,
                    disableArrowKeys: true,
                    items: itemList,
                    itemRender: renderItem,
                    onSelect: handleSelect,
                    listAttrs: {
                      style: 'height: calc(100vh - 520px);'
                    }
                  }) :
                  m(EmptyState, {
                    icon: Icons.ARCHIVE,
                    content: this.getText("LT00000317", "No results found"),
                    fill: true,
                    style: 'color: #B5B5B5',
                  }),
                isSearching &&
                m(Spinner, {
                  active: isSearching,
                  background: true,
                  fill: true,
                  size: 'xl',
                })
              )
            )
          )
        ),
        itemList && itemList.length > 199 &&
        m(Callout, {
          content: this.getText("LT00000320", "Only top 200 records are shown due to large result set"),
          icon: Icons.ALERT_CIRCLE,
          intent: Intent.WARNING,
        }),
        this.getBaseViews()
      )
    }
  }

  return {
    oninit: (vnode) => {
      onClose = vnode.attrs.onClose;
    },
    onupdate: (vnode) => {
      const conditions =
        vnode.attrs.isOpen &&
        (updateItem.siteID !== vnode.attrs.updateItem.siteID ||
          updateItem.gscmDivision !== vnode.attrs.updateItem.gscmDivision ||
          updateItem.repSoldToCode !== vnode.attrs.updateItem.repSoldToCode);
      if(conditions) {
        updateItem = vnode.attrs.updateItem;
        representativeShipToNameOrId = vnode.attrs.updateItem.repSoldToCode;
        search();
        selectedItem = { code: representativeShipToNameOrId, name: ''};
      }
    },
    view: ({ attrs: {  isOpen } }) => {
      return m(Dialog, {
        closeOnOutsideClick: false,
        isOpen: isOpen,
        onClose: onClose,
        title: this.getText("LT00000827", "Update Representative Sold-To"),
        content: m(Content),
        footer: m('.d-flex.gap-2.justify-content-end',
                  m('button.btn.btn-primary', 
                    { 
                      intent: Intent.PRIMARY, 
                      onclick: () => { handleUpdate(); } 
                    }, 
                    this.getText("LT00000043", "Confirm")
                  ),
                  m('button.btn.btn-white', 
                    { 
                      onclick: onClose
                    }, 
                    this.getText("LT00000021", "Close")
                  )
                )
      })
    }
  }
}
